export default function flagItemModal(imgSrc,legend){
    return `
        <div class="flag-modal">
            <img src="${imgSrc}" alt="flag-modal" class="flag-img">
            <span class="flag-legend">${legend}</span>
        </div>
    `;
}